import script from "./CSVConfigSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./CSVConfigSelector.vue?vue&type=script&setup=true&lang=ts"

import "./CSVConfigSelector.vue?vue&type=style&index=0&id=132c453c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\t.matsutake\\workspace\\vue_ws\\EISStudio\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-132c453c"]])

export default __exports__